import {IRegulationPresetValues} from '../regulation-preset-values.interface';

export const MALTA_PRESETS_VALUES: IRegulationPresetValues = {
    sdk: {
        Skin: {
            regulationID: 16,
            brandID: 0,
            subBrandID: 0
        },
        Currency: {
            anonymousCurrency: 'USD'
        },
        OAuth2: {
            fakeClientIP: '5.62.83.160'
        }
    },
    orbit: {
        country: 'deu',
        language: 'eng',
        iso2: 'en',
        publicationID: 1841,
        cmsSource: 'https://www.888casino.com'
    }
};